module.exports = (__webpack_require__(24))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/classCallCheck.js from dll-reference lib_core
// module id = 147
// module chunks = 109